<div [formGroup]="formGroup">
  <div>
    <mat-form-field>
      <input id="regnr" matInput placeholder="Registreringsnr." aria-label="Registrerings Nummer" formControlName="registreringsnr" />
      @if (formGroup.controls.registreringsnr.hasError('pattern')) {
        <mat-error> Reg.nr. skal bestå af 4 tal. </mat-error>
      }
    </mat-form-field>
  </div>
  <div>
    <mat-form-field>
      <input id="kontonr" matInput placeholder="Kontonr." aria-label="Konto Nummer" formControlName="kontonr" />
      @if (formGroup.controls.kontonr.hasError('pattern')) {
        <mat-error> Kontonr. skal bestå af 10 tal. </mat-error>
      }
    </mat-form-field>
  </div>
</div>
